import { useTranslation } from "react-i18next";
import { Contacts } from "../../../../redux/apiSpecifications/apiSubjects";
import { FormRow } from "../../../../style/form";
import { InputTextStyled } from "../../../../style/Input";
import { RowSpacer } from "../../../../style/containers";
import { useEffect, useMemo } from "react";
import FormModal from "../../../Modals/FormModal";
import useFormData from "../../../../hooks/useFormData";

export const validateSubjectContactsForm = (contacts: Contacts | undefined) => {
  if (!contacts) return false;

  return true;
};

interface ISubjectContactsFormProps {
  subjectContacts?: Contacts;
  disableForm?: boolean;
  onChange?: (subjectContacts: Contacts) => void;
}

const SubjectContactsForm = ({
  subjectContacts,
  disableForm,
  onChange,
}: ISubjectContactsFormProps) => {
  const { t } = useTranslation();

  const handleOnChange = (value: any, field: string) => {
    if (onChange)
      onChange({
        ...subjectContacts,
        [field]: value,
      });
  };

  return (
    <>
      <FormRow>
        <InputTextStyled
          label={t("LABELS.email")}
          placeholder={t("PLACEHOLDERS.email")}
          onChange={(value) => handleOnChange(value, "email")}
          value={subjectContacts?.email}
          disabled={disableForm}
          // required={true}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.email-other")}
          placeholder={t("PLACEHOLDERS.email-other")}
          onChange={(value) => handleOnChange(value, "emailOther")}
          value={subjectContacts?.emailOther}
          disabled={disableForm}
          // required={true}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.legal-mail")}
          placeholder={t("PLACEHOLDERS.legal-mail")}
          onChange={(value) => handleOnChange(value, "legalMail")}
          value={subjectContacts?.legalMail}
          disabled={disableForm}
          // required={true}
        />
      </FormRow>

      <FormRow>
        <InputTextStyled
          label={t("LABELS.phone")}
          placeholder={t("PLACEHOLDERS.phone")}
          onChange={(value) => handleOnChange(value, "phone")}
          value={subjectContacts?.phone}
          disabled={disableForm}
          // required={true}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.phone-other")}
          placeholder={t("PLACEHOLDERS.phone-other")}
          onChange={(value) => handleOnChange(value, "phoneOther")}
          value={subjectContacts?.phoneOther}
          disabled={disableForm}
          // required={true}
        />
      </FormRow>
    </>
  );
};

export default SubjectContactsForm;

interface ISubjectContactsModalProps {
  open: boolean;
  subjectContacts?: Contacts;
  onCancel: () => void;
  onConfirm: (subjectContacts: Contacts) => void;
}

export const SubjectContactsModal = ({
  open,
  subjectContacts,
  onCancel,
  onConfirm,
}: ISubjectContactsModalProps) => {
  const { t } = useTranslation();

  const {
    formData: _subjectContacts,
    setFormData: setSubjectContacts,
    onChangeFormData: onChangeSubjectContacts,
  } = useFormData<Contacts>();

  useEffect(() => {
    if (open) {
      setSubjectContacts(subjectContacts);
    }
  }, [open]);

  const handleOnConfirmSubjectContacts = () => {
    onConfirm({ ..._subjectContacts! });
  };

  const isSubjectPaymentValid = useMemo(() => {
    return validateSubjectContactsForm(_subjectContacts);
  }, [_subjectContacts]);

  return (
    <FormModal
      title={t("MODALS.TITLE.subject-contacts")!}
      open={open}
      isConfirmButtonDisabled={!isSubjectPaymentValid}
      onCancel={onCancel}
      onConfirm={handleOnConfirmSubjectContacts}
    >
      {_subjectContacts && (
        <SubjectContactsForm
          subjectContacts={_subjectContacts}
          onChange={(subjectContacts) => setSubjectContacts(subjectContacts)}
        />
      )}
    </FormModal>
  );
};
